import React from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";

export const CancelButton = ({ onClick, children = "Cancel", disabled = false }) => (
    <button
        type="button"
        className="action-button watchlists-cancel-button"
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </button>
);

export const SaveButton = ({ onClick, children = "Save", disabled = false }) => (
    <button
        type="button"
        className="action-button save-button"
        onClick={onClick}
        disabled={disabled}
        style={{ marginRight: 0 }}
    >
        {children}
    </button>
);

export const DeleteButton = ({ onClick, children = "Delete", disabled = false }) => (
    <button
        type="button"
        className="action-button delete-button"
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </button>
);

export const PrimaryPillButton = ({ onClick, children, disabled = false, className = "" }) => (
    <span
        role="button"
        tabIndex={disabled ? -1 : 0}
        onClick={disabled ? undefined : onClick}
        onKeyDown={(e) => {
            if (disabled) return;
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick?.(e);
            }
        }}
        className={`edit-rims-edit-button${className ? ` ${className}` : ""}`}
        style={{ borderRadius: "20px", opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? "none" : "auto" }}
    >
        {children}
    </span>
);

export const ActionButtonsRow = ({ isLoading, children, justifyContent = "flex-end" }) => (
    <div className="watchlists-action-buttons" style={{ justifyContent }}>
        {isLoading ? <LoadingSpinnerImage /> : children}
    </div>
);
